import { countriesCode } from '@share/constants';

import { PaymentFormValues } from './types';

export const ZERO = 0;
/** Minimum charge per card for multicard full pay and instalment multicard deposit (USD). */
export const MIN_MULTICARD_SPLIT_CARD_AMOUNT_USD = 10;
export const MAX_LENGTH_NAME = 35;
export const MIN_LENGTH_LAST_NAME = 2;
export const MIN_LENGTH_PASSWORD = 5;
export const MAX_LENGTH_PHONE = 12;
export const MAX_LENGTH_ADDRESS = 100;
export const MAX_LENGTH_POSTAL = 20;
export const LATIN_LETTERS_PATTERN = /^[a-zA-Z\s\-'\.]+$/;
export const CARD_CVC_MIN = 3;
export const CARD_EXPIRY_PATTERN = /^[0-9]{2}\/[0-9]{2}$/;
export const CARD_NUMBER_MIN = 16;

export const COUNTRY_OPTIONS = countriesCode.map((code) => ({
  value: code.isoCode,
  label: code.name,
}));

export const INITIAL_VALUES: PaymentFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
  paymentPlan: 'full',
  splitPayInFull: false,
  splitInstalmentDown: false,
  instalmentMonths: 4,
  downPaymentAmount: '',
  splitAmount1: '',
  splitAmount2: '',
  billingAddressSameAsFirst: false,
  addressLine2: '',
  city2: '',
  country2: 'US',
  postalCode2: '',
  splitDownAmount1: '',
  splitDownAmount2: '',
  primaryInstalmentCard: 'card1',
  nameOnCard: '',
  nameOnCard2: '',
  addressLine: '',
  city: '',
  country: 'US',
  postalCode: '',
  agreeCharge: false,
  agreeTerms: false,
  cardNumber: '',
  cardExpiry: '',
  cardCvc: '',
  cardNumber2: '',
  cardExpiry2: '',
  cardCvc2: '',
};
